export default __webpack_public_path__ + "2308b2fc62d6a6224dac8aa31910d91e.svg";